import {
    computerMenuText,
    cloudLocationsMenuText,
    uploadAndShareFromCloudMenuText,
    uploadAndShareFromCloudMenuTooltip,
} from './attachmentMultiMenuEntry.locstring.json';
import loc from 'owa-localize';
import getCreateAttachmentHandlerForLocalFile from './getCreateAttachmentHandlerForLocalFile';
import { getCreateAttachmentHandlerForUpsell } from './getCreateAttachmentHandlerForUpsell';
import AttachmentMultiMenuEntry from '../types/AttachmentMultiMenuEntry';
import { logUsage } from 'owa-analytics';
import { CreateAttachmentHandlerParams } from 'owa-attachment-filepicker';
import { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const styles = require('../components/AttachmentMultiMenuEntryIcons.scss');
const classNames = require('classnames/bind').bind(styles);

const attachmentMultiMenuEntry: AttachmentMultiMenuEntry = {
    computer: {
        isEnabled: () => true,
        text: () => loc(computerMenuText),
        iconProps: {
            iconName: ControlIcons.System,
            styles: {
                root: classNames(styles.iconRoot, styles.iconRootComputer),
            },
        },
        getCreateAttachmentHandler: getCreateAttachmentHandlerForLocalFile,
        logUsage: (entrySource: { toString: () => string }) => {
            logUsage('FPDualEntryComputer', { entrySource: entrySource.toString() });
        },
    },
    onlineLocation: {
        isEnabled: () => true,
        text: () => loc(cloudLocationsMenuText),
        iconProps: {
            iconName: ControlIcons.Cloud,
            styles: {
                root: classNames(styles.iconRoot, styles.iconRootCloud),
            },
        },
        getCreateAttachmentHandler: (_, createAttachment) => {
            return (createAttachmentHandlerParams: CreateAttachmentHandlerParams) => {
                const baseProperties = {
                    isInline: createAttachmentHandlerParams.isInline,
                    isHiddenInline: false,
                };
                const properties: CreateAttachmentsProperties = createAttachmentHandlerParams.shouldShare
                    ? { ...baseProperties, shouldShare: true }
                    : { ...baseProperties, shouldShare: false };

                createAttachment(
                    createAttachmentHandlerParams.files,
                    properties,
                    createAttachmentHandlerParams.dataProviderType
                );
            };
        },
        logUsage: (entrySource: { toString: () => string }) => {
            logUsage('FPDualEntryFilePicker', { entrySource: entrySource.toString() });
        },
    },
    uploadAndShareFromCloud: {
        isEnabled: () => {
            const configuration = getUserConfiguration();
            return (
                isFeatureEnabled('doc-attachment-upsellEntryPoint') &&
                configuration.AttachmentPolicy.AttachmentDataProviderAvailable &&
                configuration.AttachmentPolicy.ReferenceAttachmentsEnabled
            );
        },
        text: () => loc(uploadAndShareFromCloudMenuText),
        ariaLabel: () => loc(uploadAndShareFromCloudMenuTooltip),
        iconProps: {
            iconName: ControlIcons.CloudUpload,
            styles: {
                root: classNames(styles.iconRoot, styles.iconRootUploadAndShare),
            },
        },
        getCreateAttachmentHandler: getCreateAttachmentHandlerForUpsell,
        logUsage: (entrySource: { toString: () => string }) => {
            logUsage('FPMultiEntryUploadAndShareFromCloud', {
                entrySource: entrySource.toString(),
            });
        },
    },
};

export default attachmentMultiMenuEntry;
